// extracted by mini-css-extract-plugin
export default {"FormStep2":"FormStep2_FormStep2__Jm0AY"};